import gql from 'graphql-tag'
export default gql`
  query ModalRegister {
    modalRegister @client {
      isOpen
      isBack
    }
  }
`;